module.exports = __webpack_public_path__ + "static/media/calig-light.384bfb74.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/calig-light.png
// module id = 31
// module chunks = 0